function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M300.19 246L484.14 62.04A26.77 26.77 0 00492 43.02c0-7.21-2.8-13.98-7.86-19.03L468.02 7.87A26.69 26.69 0 00448.98.02c-7.2 0-13.95 2.78-19.02 7.85L246.01 191.82 62.05 7.87A26.66 26.66 0 0043.02.02C35.82.02 29.06 2.8 24 7.87L7.87 24a26.93 26.93 0 000 38.05L191.83 246 7.87 429.95a26.75 26.75 0 00-7.85 19.03c0 7.2 2.79 13.96 7.85 19.03L24 484.13a26.68 26.68 0 0019.02 7.85c7.2 0 13.96-2.78 19.02-7.85L246 300.18l183.96 183.95a26.7 26.7 0 0019.02 7.85 26.7 26.7 0 0019.04-7.85L484.14 468a26.74 26.74 0 007.85-19.03c0-7.2-2.8-13.96-7.85-19.02L300.19 246z"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 492 492",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.a0a10f69.svg";
export { ForwardRef as ReactComponent };